<template>
  <div class="fundo-principal">
    <div class="container">
      <div class="form-control div-geral">
        <div class="row div-interna">
          <div class="col-12 col-sm-6 fundo-esquerda">
            <div class="imgLogin">
              <img class="w-100 mb-2 imgLogo" :src="logo_escrita" alt="" width="350" height="350" />
            </div>
            <div class="descLogin text-center">
              <p>O esforço de hoje é o <br>sucesso de amanhã, feliz 2025!</p>
            </div>
          </div>
          <div class="col-12 col-sm-6 div-direita">
            <div class="header">
              <h6>{{ $t('ACESSO AO SISTEMA') }}</h6>
              <h1>{{ $t('Terminal Oficina') }}</h1>
              <p>{{ $t('Realize o login e tenha acesso ao controle') }} <br> {{ $t('e gestão de suas Ordens de Serviço')
                }}</p>
            </div>
            <hr>
            <div class="content">
              <form action="../../index3.html" method="post">
                <div class="">
                  <div class="row col-md-12 p-md-0 px-sm-3" style="align-items: center">
                    <div class="col-7">
                      <h5>{{ $t('Mecânico Externo') }}: </h5>
                    </div>
                    <div class="switch__container col-5">
                      <input id="switch-shadow" @click="empresaExterno = !empresaExterno"
                        v-model.trim="form.loginExterno" class="switch switch--shadow" type="checkbox">
                      <label for="switch-shadow"></label>
                    </div>
                  </div>
                  <div class="col-md-10 col-10 mb-0 p-md-0 px-sm-3 inputLogin">
                    <v-select id="inputEmpresa" :options="empresas" v-model="empresaSelected"
                      @input="setEmpresaLogin(empresaSelected)" style="font-size: 19px;"
                      placeholder="Selecione a empresa" />
                  </div>
                  <div class="row ml-0 pl-0 col-12">
                    <div class="col-md-5 mr-1 col-10 p-md-0 px-sm-3 inputLogin" v-show="this.empresaExterno">
                      <input type="number" id="inputMatricula" class="form-control form-control-lg"
                        :disabled="disabledCookie" :class="{ 'is-invalid': hasError }" v-model.trim="form.matricula"
                        placeholder="Matrícula" @keyup.enter="doLogin()" required autofocus />
                    </div>
                    <div class="col-md-5 mr-1 col-10 p-md-0 px-sm-3 inputLogin" v-show="!this.empresaExterno">
                      <input type="number" id="inputNrsequencial" class="form-control form-control-lg"
                        :disabled="disabledCookie" :class="{ 'is-invalid': hasError }" v-model.trim="form.nr_sequencial"
                        placeholder="Código" @keyup.enter="doLogin()" required autofocus />
                    </div>
                    <div class="col-md-5 col-10 p-md-0 px-sm-3 pt-sm-2 pb-sm-2 inputLogin" v-show="this.empresaExterno">
                      <label for="inputSenha" class="sr-only">CPF</label>
                      <input type="password" id="inputSenha" maxlength="3" class="form-control form-control-lg"
                        :disabled="disabledCookie" :class="{ 'is-invalid': hasError }" v-model.trim="form.cpf"
                        placeholder="CPF (3 primeiros digitos)" @keyup.enter="doLogin()" required />
                    </div>
                    <div class="col-md-5 col-10 p-md-0 px-sm-3 pt-sm-2 pb-sm-2 inputLogin"
                      v-show="!this.empresaExterno">
                      <label for="inputCNPJ" class="sr-only">CNPJ</label>
                      <input type="number" id="inputCNPJ" maxlength="5" class="form-control form-control-lg"
                        :disabled="disabledCookie" :class="{ 'is-invalid': hasError }" v-model.trim="form.cnpj"
                        placeholder="CNPJ (5 primeiros dígitos)" @keyup.enter="doLogin()" required />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-10 col-md-5 mr-1 mb-1">
                      <button class="btn btn-lg btn-block btnAccess text-center" type="button" @click="doLogin()"
                        :disabled="loading">
                        <i class="fa fa-share mr-1" aria-hidden="true"></i>{{ $t('Acessar') }}
                      </button>
                    </div>
                    <div class="col-10  col-md-6">
                      <button class="btn btn-lg btn-block btnAccess text-center" type="button"
                        v-b-modal.modal-acesso-rapido :disabled="loading" @click="populaAcessos">
                        <i class="fa fa-bolt mr-1" aria-hidden="true"></i>{{ $t('Acesso Rápido') }}
                      </button>
                    </div>
                  </div>
                  <div class="mt-3">
                    <a href="https://web.whatsapp.com/send?phone=554991698966" target="_blank"
                      style="color: #454545;">{{ this.$t('Precisa de Ajuda?') }}</a>
                  </div>
                </div>
                <div class="row text-sm text-right">
                  <p class="text-muted" v-if="loading">Carregando...</p>
                  <p class="text-danger" v-if="hasError">
                    {{ $t('Falha ao fazer login') }}
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-avaliacao @fechaModal="showAvaliacao = false" :pesquisa="pesquisa"></modal-avaliacao>
    <modal-acesso-rapido ref="modalAcessos" @acessoRapido="acessoRapido"></modal-acesso-rapido>
  </div>
</template>

<script>
import ModalAvaliacao from '@/components/Modais/ModalAvaliacao'
import ModalAcessoRapido from '@/components/Modais/ModalAcessoRapido'

export default {
  name: 'Login',
  data: () => {
    return {
      form: {
        matricula: '',
        cpf: '',
        loginExterno: false,
      },
      hasError: false,
      loading: false,
      todasEmpresas: ['GRUPOT2P', 'I9_DEMONSTRACAO', 'LOG20', 'MADEPAR', 'NEXWAY', 'OP.DEDICADAS', 'TSV', 'AMBEV'],
      empresaExterno: true,
      empresaSelected: '',
      disabledCookie: true,
      pesquisa: ''
    }
  },

  components: {
    ModalAvaliacao,
    ModalAcessoRapido
  },

  computed: {
    logo() {
      return this.$store.state.logo
    },
    logo_escrita() {
      return this.$store.state.logo_escrita
    },
    anoAtual() {
      return this.$store.state.anoAtual
    },
    empresas() {
      let empresas = this.$store.getters['os/getEmpresas']

      if (!empresas) {
        this.$store.dispatch('os/getEmpresas')

        return []
      }

      return empresas.map(empresa => {
        return {
          ...empresa,
          label: empresa.name.toUpperCase()
        }
      })
    }
  },

  created() {
    this.empresaSelected = this.getEmpresaLogada()
    // localStorage.empresaFilial = JSON.stringify(this.getEmpresaLogada().label)
    this.functionDisabledCookie()
    this.$store.dispatch('os/getEmpresas') 
    this.loginSalvo()
  },

  methods: {

    loginSalvo() {
      try {
        if (localStorage.saveLogin != undefined) {
          const saveLogin = JSON.parse(localStorage.saveLogin)

          this.form.matricula = saveLogin.matricula
          this.form.cpf = saveLogin.cpf
        }
      } catch (error) {
        throw Error(error)
      }
    },

    functionDisabledCookie() {
      if (localStorage.empresa != undefined) {
        const cookieEmpresa = JSON.parse(localStorage.empresa)

        if (cookieEmpresa && !(cookieEmpresa === 'Selecione uma empresa') && this.empresaSelected != '') {
          this.disabledCookie = false
        } else {
          this.disabledCookie = true
        }
      } else {
        this.disabledCookie = true
      }
    },

    getEmpresaLogada() {
      if (localStorage.empresa != undefined) {
        const cookieEmpresa = JSON.parse(localStorage.empresa)

        if (cookieEmpresa) {
          var empresa = cookieEmpresa
        }

        return empresa
      }
    },

    async setEmpresaLogin(empresa) {
      if (empresa == null) {
        empresa = 'Selecione uma empresa'
      }

      try {
        const cookieEmpresa = JSON.parse(localStorage.empresa)

        if (cookieEmpresa == "Selecione uma empresa") {
          localStorage.empresa = JSON.stringify(empresa)
          // localStorage.empresaFilial = JSON.stringify(empresa.label)
          window.location.reload()
        }

        localStorage.empresa = JSON.stringify(empresa)
        // localStorage.empresaFilial = JSON.stringify(empresa.label)
      } catch (error) {
        localStorage.empresa = JSON.stringify(empresa)
        // localStorage.empresaFilial = JSON.stringify(empresa.label)
        window.location.reload()
      }

      window.location.reload()

      this.functionDisabledCookie()
    },

    logout() {
      this.$swal.fire({
        title: 'Oops!',
        text: 'Sua sessão expirou. Por favor, faça o login novamente.',
        icon: 'error'
      })

      this.$store.dispatch('filial/logout')
    },

    validaForm() {
      if (this.form.loginExterno) {
        if (!this.form.nr_sequencial || !this.form.cnpj) {
          this.$swal.fire({
            title: 'Oops!',
            text: 'Insira todas as informações!',
            icon: 'error'
          })
          return false
        } else {
          return true
        }
      } else {
        if (!this.form.matricula || !this.form.cpf) {
          this.$swal.fire({
            title: 'Oops!',
            text: 'Insira todas as informações!',
            icon: 'error'
          })
          return false
        } else {
          return true

        }
      }
    },
    acessoRapido(acesso){
      console.log(acesso)
      this.form.cpf = acesso.cpf
      this.form.matricula = acesso.matricula
      this.form.ds_empresa = acesso.empresa

      this.doLogin()
    },

    populaAcessos(){
      this.$refs.modalAcessos.populaAcessos()
    },

    salvarAcessoRapido(response) {

      const dataAcesso = {
        nome: response.data.dsColaborador,
        matricula: this.form.matricula,
        cpf: this.form.cpf,
        filial: response.data.filial.ds_filial,
        empresa: this.form.ds_empresa
      }

      try {
        let array = JSON.parse(localStorage.getItem('acessoRapido')) || [];

        let found = false;

        array.forEach(obj => {
          if (obj.matricula === dataAcesso.matricula) {
            obj = dataAcesso;
            found = true;
          }
        });

        if (!found) {
          array.push(dataAcesso);
        }

        localStorage.setItem('acessoRapido', JSON.stringify(array));

      } catch (error) {
        let array = JSON.parse(localStorage.getItem('acessoRapido')) || [];

        array.push(dataAcesso);

        localStorage.setItem('acessoRapido', JSON.stringify(array));

      }
    },

    async doLogin() {
      if (this.validaForm()) {
        // await setUnauthorizedCallback(this.logout)
        this.hasError = false
        this.loading = true

        if(!this.form.ds_empresa){
          this.form.ds_empresa = this.empresaSelected.name.toUpperCase()
        }

        this.$store
          .dispatch('filial/login', { data: this.form })
          .then(response => {
            this.salvarAcessoRapido(response)

            this.hasError = false
            localStorage.saveLogin = JSON.stringify(this.form)
            const filial = this.$store.getters['filial/filial']

            let exibirModal = false;

            response.data.pesquisa_nps.forEach(user => {
              if (user.nr_nota == null) {
                exibirModal = true;
                this.pesquisa = {
                  tecnicoId: response.data.tecnicoId,
                  nr_seq_pesquisa: user.nr_sequencial,
                  loginExterno: this.form.loginExterno
                }

                this.$root.exibirModalAvaliacao(response)

              }
            });

            if (exibirModal) {
              this.$bvModal.show('modal-avaliacao');
            } else {
              this.executarRedirecionamento(filial);
            }

          })
          .catch((err) => {
            console.error(err)
            this.hasError = true
          })
          .finally(() => {
            this.loading = false
          })
      }
    },

    executarRedirecionamento(filial) {
      if (filial.fornecExt === 'S') {
        window.location = '/osExterna'
        return false
      }

      if(filial.tipoPerfilTerminal == 'C' || filial.tipoPerfilTerminal == 'T'){
        window.location = '/'
        return false
      }

      if(filial.tipoPerfilTerminal == 'E'){
        window.location = '/osEmpilhadeira'
        return false
      }

      // if (filial.perfilMecanico == 'E') {
      //   this.$router.push('/osEmpilhadeira').catch(err => { console.error(err) })
      // } else if (filial.fornecExt === 'S') { 
      //   this.$router.push('/osExterna').catch(err => { console.error(err) })
      // } else {
      //   this.$router.push('/').catch(err => { console.error(err) })
      // }
    }
  }
}
</script>
<style scoped>

  /* Estilo iOS */
  .switch__container {
    margin: 0px auto;
    width: 120px;
  }

  .switch {
    visibility: hidden;
    position: absolute;
    margin-left: -9999px;
  }

  .switch+label {
    display: block;
    position: relative;
    cursor: pointer;
    outline: none;
    user-select: none;
  }

  .switch--shadow+label {
    padding: 2px;
    width: 80px;
    height: 40px;
    background-color: #dddddd;
    border-radius: 60px;
  }

  .switch--shadow+label:before,
  .switch--shadow+label:after {
    display: block;
    position: absolute;
    top: 1px;
    left: 1px;
    bottom: 1px;
    content: "";
  }

  .switch--shadow+label:before {
    right: 1px;
    background-color: #f1f1f1;
    border-radius: 60px;
    transition: background 0.4s;
  }

  .switch--shadow+label:after {
    width: 38px;
    height: 38px;
    background-color: #fff;
    border-radius: 100%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    transition: all 0.4s;
  }

  .switch--shadow:checked+label:before {
    background-color: #8ce196;
  }

  .switch--shadow:checked+label:after {
    transform: translateX(40px);
  }

  /* Estilo Flat */
  .switch--flat+label {
    padding: 2px;
    width: 120px;
    height: 60px;
    background-color: #dddddd;
    border-radius: 60px;
    transition: background 0.4s;
  }

  .switch--flat+label:before,
  .switch--flat+label:after {
    display: block;
    position: absolute;
    content: "";
  }

  .switch--flat+label:before {
    top: 2px;
    left: 2px;
    bottom: 2px;
    right: 2px;
    background-color: #fff;
    border-radius: 60px;
    transition: background 0.4s;
  }

  .switch--flat+label:after {
    top: 4px;
    left: 4px;
    bottom: 4px;
    width: 56px;
    background-color: #dddddd;
    border-radius: 52px;
    transition: margin 0.4s, background 0.4s;
  }

  .switch--flat:checked+label {
    background-color: #8ce196;
  }

  .switch--flat:checked+label:after {
    margin-left: 60px;
    background-color: #8ce196;
  }

  @media screen and (max-width: 769px) {
    .container {
      padding-right: 3px;
      padding-left: 3px;
    }

  }

  @media screen and (max-width: 575px) {
    .container {
      padding-right: 3px;
      padding-left: 3px;
    }

    .div-interna {
      width: 100vh;
    }

    .div-geral {
      align-items: center;
      display: flex;
      margin-top: -66px;
      height: 100vh;
    }

    .inputLogin {
      margin: 5px 0px 20px -13px !important;
    }

    .imgLogo {
      width: 175px !important;
      height: 175px;
      margin-bottom: -71px !important;
    }

    .imgLogin {
      margin: -89px 0px;
      display: flex;
      justify-content: center;
    }

    .imgLogo {
      width: 250px !important;
      height: 250px;
      margin-bottom: -17px !important;
    }

    .form-login {
      border-bottom-right-radius: 32px;
      border-bottom-left-radius: 32px;
      border-top-left-radius: 0px !important;
      border-top-right-radius: 0px !important;
    }

    .fundo-esquerda {
      height: 250px !important;
      margin-bottom: -40px;
      border-radius: 0px !important;
      height: 340px !important;
      padding: 15% 0px !important;
      margin-top: -33% !important;
    }

    .img-logo {
      height: 30px;
      margin-bottom: 78px !important;
    }

    .header h6 {
      display: none;
    }

    .header p {
      display: contents;
      font-size: 14px;
    }

    .header h1 {
      font-size: 29px;
    }

    #div-esquerda {
      margin-bottom: -1px;
      background-color: #fff;
      border-top-left-radius: 39px !important;
      border-top-right-radius: 39px;
      border-bottom-left-radius: 0px !important;
    }

    .div-direita {
      border-top-left-radius: 144px 100px !important;
      border-top-right-radius: 10px 10px !important;
      box-shadow: -1px -2px 10px #4f4f4f;
      margin-left: 0px !important;
      padding: 45px 0px 49px 56px !important;
      margin-top: -50px;
    }

    .cabecalho-esquerda {
      margin-top: -33px;
      margin-bottom: -60px !important;
    }

    #titulo-portal {
      display: none;
    }

    .logo {
      width: 171px;
      height: 173px;
    }

    .login-direita {
      margin-top: -82px;
      padding: 7%;
    }

    .login-esquerda {

      margin-left: 0px !important;
    }

    .form-login {
      padding: 0;
    }
  }

  .vs__search {
    height: 40px;
  }

  .container {
    display: flex;
    align-items: center;
    height: 100vh;
  }

  .inputLogin {
    margin: 20px 0px;
  }

  .btnAccess {
    border-radius: 25px;
    color: #fff;
    background: linear-gradient(88deg, #6cbf65ab, #177174);
    background-color: #000;
  }

  .div-geral {
    height: 560px;
    background: transparent;
    border: none;
  }

  .fundo-principal {
    background-image: linear-gradient(to right, #00000082, #00000082), url('../assets/backgroundLogin.jpeg');
    height: 100vh;
    background-size: cover;
  }

  .footer-basic {
    background: transparent;
  }

  .descLogin {
    display: flex;
    justify-content: center;
    font-size: 19px;
    color: #fff;
  }

  .fundo-esquerda {
    /* background: url(assets/img/Logo-index.jpeg) center / cover; */
    background: linear-gradient(45deg, #6cbf65ab, #177174);
    width: auto;
    height: 560px;
    border-radius: 32px;
    display: grid;
    justify-content: center;
    align-items: center;
  }

  .col-12 {
    padding: 0px;
  }

  .register-photo form .btn-primary {
    background: linear-gradient(45deg, #a70c6a, #080a55);

  }

  .header {
    color: #000;
  }

  .div-direita {
    background: #fff;
    margin-left: -40px;
    border-radius: 20px;
    padding: 70px 0px 40px 70px;
  }

  .conteudo-esquerda {
    color: #ffffff;
    font-size: 14px;
    font-family: poppins;
    padding: 10%;
  }
</style>